<template>

    <div  >
        <ul >
            <li   v-for="item in imgList">
                <div class="image-container">
                    <img :src="item.url"   class="small-image"  @click="showimg(item)">
                </div>
            </li>
            <li   v-for="item in fileList" @click="download(item)">
                <div class="small-file" >
                  {{item.filename}}
                </div>
            </li>
        </ul>

    </div>



</template>
<script>
    import{erpplatfileserver,file_url,baseApp,baseVersion} from '@/utils/baseUrl';
    import {file_root} from "../../../utils/baseUrl";

    export default {
        name: "fujian",
        props: {
            fj: Object,
        } ,
        watch: {
            fj(n,o){

                this.initfile(n);
            },
        },
        data() {
            return {
                fileList:[],
                imgList:[],

            }
        },



        methods: {
            initfile(n)
            {
                this.imgList=[];
                this.fileList=[];
                if (n.hasOwnProperty("option"))
                {
                    let option=n.option;
                    let str=n.fj
                    let a=JSON.parse(str.slice(str.indexOf('{')));
                    let files=a[option.files];
                    this.fileList.push({'filename':files[option.filename],'fileNewName': files[option.newname]});
                }
                else   if (n.hasOwnProperty("fj"))
                {
                    let str=n.fj
                    let regex = /\[(.+?)\]/g;
                    if (str.match(regex))
                    {
                        let a=JSON.parse(str.match(regex));

                        this.fileList=a;
                    }
                    else {
                        let f = str.split(";");
                        for (let i = 0; i < f.length; i++) {
                            const fileName = f[i].split('/').pop();
                            let ftype = f[i].split('.').pop();
                            let path = f[i];
                            if (!(path.includes('https://')||path.includes('http://'))) {
                                path = file_root + path;
                            }
                            if (ftype == 'jpg'  || ftype == 'jpeg' || ftype == 'png' || ftype == 'gif')
                                this.imgList.push({'filename':fileName,'url':path});
                            else
                                this.fileList.push({'filename':fileName,'url':path});
                        }
                    }
                }

            },
            showimg(item) {
                window.open(item.url);
            },
            download(item){
                if (item.hasOwnProperty('url'))
                {
                    window.open(item.url);
                }
                else {
                    let new_params = {};
                    new_params.token = sessionStorage.getItem("token");
                    new_params.i_uid = sessionStorage.getItem("userid");
                    new_params.app = baseApp;
                    new_params.version = baseVersion;
                    let fileUrl = file_url + 'param=' + encodeURI('{app:\'' + baseApp + '\',i_uid:\'' + new_params.i_uid +
                        '\',token:\'' + new_params.token + '\',version:\'' + new_params.version + '\',fid:\'' + item.fileNewName +
                        '\'}', 'utf-8');
                    window.open(fileUrl);
                }

            },

        }
    }

</script>

<style lang="scss" >

    .ul_list {

        .li {
            width: 200px;
            margin:0px;
            height: 120px;
            display: flex;
            background-color: #ccd0dd;
        }
    }

 .small-image {
     width: 180px;
     margin: 4px;
     height: 120px;
     cursor: pointer;
     opacity: 0.5;
     background-color: #f9f9f9;
 }
    .small-image:hover{
        background: #f9f9f9;
        opacity: 0.95;
    }
 .small-file {
     width: 180px;
     margin: 4px;
     height: 120px;
     justify-content: center;
     text-align: center;
     align-items: center;
     line-height: 30px;
     font-size: 15px;
     display: flex;
     outline: none;
     cursor: pointer;
     background-color: #f9f9f9;
     color: #ad630e;
     opacity: 0.5;
 }
    .small-file:hover{
         background: #f9f9f9;
        opacity: 0.95;
     }


</style>